// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from "react";
import { useTranslation } from "react-i18next";

import { FormField, Select } from "@cloudscape-design/components";
import { SelectProps } from "@cloudscape-design/components/select";

function generateBillingPeriods(): SelectProps.Option[] {
	const options: SelectProps.Option[] = [];
	const now = new Date();
	for (let i = 0; i < 12; i++) {
		const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
		const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
		options.push({ value, label: value });
	}
	return options;
}

const billingPeriodOptions = generateBillingPeriods();

interface BillingPeriodSelectorProps {
	selectedPeriod: string;
	onChange: (period: string) => void;
}

export default function BillingPeriodSelector({
	selectedPeriod,
	onChange,
}: BillingPeriodSelectorProps) {
	const { t } = useTranslation();

	const selectedOption =
		billingPeriodOptions.find((o) => o.value === selectedPeriod) ??
		billingPeriodOptions[0];

	return (
		<FormField label={t("usage_billing_period")}>
			<Select
				selectedOption={selectedOption}
				onChange={(e) =>
					onChange(e.detail.selectedOption.value ?? selectedPeriod)
				}
				options={billingPeriodOptions}
				data-testid="billing-period-selector"
			/>
		</FormField>
	);
}
